
var rateLess = {};
import genaration from '../../utils/classname';
export var rateClass = genaration(rateLess, 'rate');